import {useEffect, useRef, useState} from "react";
import HttpService from "../Services/HttpService";
import {toast} from "react-toastify";
import styles from './WaitingAd.module.css';
import Loader from "../../Component/Loader/Loader";
import ShowAd from "./ShowAd/ShowAd";
import {getRowStyle} from "../../Component/Tools/tools";
import NotFound from "../../Component/NotFound/NotFound";
import Button from "../../Component/Button/Button";

function WaitingAd() {
    const [invoicesDto, setInvoicesDto] = useState([]);
    const [idAdvertisment, setIdAdvertisment] = useState('');
    const [lateAd, setLateAd] = useState('')

    const fetchData = () => {
        HttpService.get("Api/Invoices")
            .then((res) => {
                setInvoicesDto(res.data);
            })
            .catch((err) => {
                toast.warn('آگهی ثبت نشده است');
            });
    };

    const fetchedOnceRef = useRef(false);
    useEffect(() => {
        if (!fetchedOnceRef.current) {
            fetchedOnceRef.current = true;
            fetchData();
        }
    }, []);


    function onClickAd(id) {
        setIdAdvertisment(id);
    }

    function onExitAd() {
        setLateAd(idAdvertisment)
        setIdAdvertisment('')
    }

    const handleEditClick = () => {
        toast.dismiss();
        setIdAdvertisment(lateAd);
        setLateAd('');
    };
    useEffect(() => {
        if (lateAd) {
            toast.warn(
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", direction: "rtl"}}>
                    <p>نیاز به اصلاح جدید اگهی قبلی دارید؟</p>
                    <div style={{display: "flex", justifyContent: "end", gap: "10px",width:"100px"}}>
                        <Button onClick={handleEditClick} text={'بله'}/>
                    </div>
                </div>,
                {
                    autoClose: 5000,       // 👈 بعد از ۵ ثانیه خودکار بسته می‌شود
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                    rtl: true,
                    onClose: () => setLateAd('') // وقتی بسته شد، مقدار lateAd رو پاک کن
                }
            );
        }
    }, [lateAd]);

    return (
        idAdvertisment !== '' ? (
            <ShowAd
                id={idAdvertisment}
                onExit={() => onExitAd()} // فقط خالی کن
            />
        ) : (
            <div className={styles.container_table}>
                {invoicesDto.length === 0 ? (
                    <NotFound/>
                ) : (
                    <table>
                        <thead>
                        <tr>
                            <th>نام آگهی</th>
                            <th>تاریخ ثبت</th>
                            <th>وضعیت</th>
                            <th>پرداختی فاکتور</th>
                        </tr>
                        </thead>
                        <tbody>
                        {invoicesDto.map((ad) => (
                            <tr key={ad.adId} onClick={() => onClickAd(ad.adId)}>
                                <td>{ad.adName}</td>
                                <td>{new Date(ad.adDate).toLocaleString('fa-IR')}</td>
                                <td style={getRowStyle(ad.condition)}>{ad.condition}</td>
                                <td>{ad.adPayment || "—"}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}

            </div>
        )
    );
}

export default WaitingAd;
